import { render, staticRenderFns } from "./CircleSoundsIcon.vue?vue&type=template&id=2da352c9&"
import script from "./CircleSoundsIcon.vue?vue&type=script&lang=js&"
export * from "./CircleSoundsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports